<script>
    import { getContext } from 'svelte';
    import { publishOpenAction } from './openable';

    export let playgroundHandled;
    export let playground;
    $: playgroundTitle = getTitle(playground);

    // Lets the sidebar open the item from the keyboard
    $: publishOpenAction(playground, action);

    let getMap = getContext('getMap');

    function getTitle(playground) {
        if (!playground) {
            return '';
        }

        if (playground.name && playground.municipality) {
            return `Ny lekplats: ${playground.name} (${playground.municipality})`;
        }

        if (playground.name) {
            return 'Ny lekplats: ' + playground.name;
        }

        if (playground.municipality) {
            return `Ny lekplats i ${playground.municipality}`;
        }

        return 'Ny lekplats';
    }

    function playgroundClosed() {
        if (!playground || !playgroundHandled) {
            return;
        }

        // Make sure the playground was indeed handled
        if (playground.state == 'draft') {
            return;
        }

        // Let the sidebar know that this item should be removed
        playgroundHandled(playground);
    }

    function action() {
        getMap().openApprovePopup(playground, playgroundClosed);
    }

</script>

<p>
    <!-- svelte-ignore a11y-missing-attribute -->
    <a on:click|preventDefault={action}>{playgroundTitle}</a>
</p>

<style>
    a {
        cursor: pointer;
    }

    p {
        margin: 0;
        padding: 0;
    }
</style>
